;(function (angular, _, moment, kiloMoneyCompute) {
  'use strict'

  const STRINGS = {
    invoice: {
      saved: 'Facture sauvegardée !',
      preFilledSaved: 'Modèle de facture pré-remplie sauvegardé',
      createCreditNote: 'Facture d\'avoir pour la facture No. ',
      cancelled: 'Facture annulée !'
    },
    quote: {
      saved: 'Devis sauvegardé !',
      preFilledSaved: 'Modèle de devis pré-remplie sauvegardé'
    },
    creditnote: {
      saved: 'Avoir sauvegardé !',
      warn_updated_prices: 'Le prix unitaires et la quantité des lignes ont été ajustés pour inclure les différentes remises.'
    }
  }

  const MODELS = {
    INVOICE: 'invoice',
    QUOTE: 'quote',
    CREDIT_NOTE: 'creditnote'
  }

  // Polling du bandeau Pennylane sur la fiche facture : tick de 5 s,
  // cap 120 ticks = 10 minutes de suivi maximum (au-delà, bandeau figé).
  const PENNYLANE_EMISSION_POLL_INTERVAL_MS = 5000
  const PENNYLANE_EMISSION_POLL_MAX_TICKS = 120

  class ElementShowController {
    // Declare all attributes for autocomplete
    $http
    $location
    $q
    $scope
    $rootScope
    $state
    $timeout
    $uibModal
    allStocks
    bpuCount
    bpuManager
    bpus
    creditNoteManager
    creditNotePagination
    creditNotes
    creditNoteService
    customFields
    datePickerService
    directPaymentInfos
    displayActivity
    displayService
    entityInfos
    errors
    exportService
    fromQuote
    fromToDeposit
    initParams
    interventionManager
    interventions
    element // Will contain either an invoice, a quote or a credit note
    manager
    service
    isAdmin
    isValidator
    loading
    paymentService
    pennylaneEmission // état du dernier envoi Pennylane affiché sur la fiche facture (U5)
    pennylanePaStatus // statut e-invoicing chez la plateforme (PA) : rejet/validation (W-1/W-2)
    preferencesService
    prefs
    referersService
    reverseVATSInfo
    selectClientConfig
    selectDeliveryConfig
    snackService
    statusService
    subcontractInfos
    theForm
    tokenSwitcherService
    urls
    utilService
    templateService
    vatList
    warnings
    vats

    constructor (
      // Urls
      urls,
      // Angular
      $http, $location, $q, $scope, $rootScope, $state, $timeout, $uibModal,
      // Managers
      BpuManager, CreditNoteManager, InterventionManager,
      // Services
      CreditNoteService, DatePickerService, DisplayService, ExportService, InvoiceService, PaymentService, PreferencesService,
      QuoteService, ReferersService, SessionService, SnackService, StatusService, TokenSwitcherService, UtilService, templateService, AppAccessService, ChorusService, PennylaneService, PennylaneEmissionTrackerService,
      // Resolve
      creditNotePagination, customFields, fromQuote, fromToDeposit, generalPrefs, initParams, element, vats, model, FileUploader, facturXMimetypes, facturXPaymentsMethod, InvoiceLineManager
    ) {
      this.model = model.toLowerCase()
      let prefsPromise

      switch (model.toLowerCase()) {
        case MODELS.INVOICE:
          this.service = InvoiceService
          prefsPromise = PreferencesService.getPrefsFor('invoice')
          break
        case MODELS.CREDIT_NOTE:
          this.service = CreditNoteService
          prefsPromise = PreferencesService.getPrefsFor('creditnote')
          break
        case MODELS.QUOTE:
          this.service = QuoteService
          prefsPromise = PreferencesService.getPrefsFor('quote')
          break
        default:
          throw new Error(`Unknown model ${model}`)
      }

      // DI
      this.$http = $http
      this.$location = $location
      this.$q = $q
      this.$scope = $scope
      this.$rootScope = $rootScope
      this.$state = $state
      this.$timeout = $timeout
      this.$uibModal = $uibModal

      this.urls = urls

      this.bpuManager = BpuManager
      this.creditNoteManager = CreditNoteManager
      this.interventionManager = InterventionManager
      this.manager = this.service.manager
      this.creditNoteService = CreditNoteService
      this.datePickerService = DatePickerService
      this.displayService = DisplayService
      this.paymentService = PaymentService
      this.preferencesService = PreferencesService
      this.referersService = ReferersService
      this.snackService = SnackService
      this.statusService = StatusService
      this.tokenSwitcherService = TokenSwitcherService
      this.utilService = UtilService
      this.templateService = templateService
      this.exportService = ExportService
      this.appAccessService = AppAccessService
      this.chorusService = ChorusService
      this.pennylaneService = PennylaneService
      this.pennylaneEmissionTrackerService = PennylaneEmissionTrackerService
      this.facturXPaymentsMethod = facturXPaymentsMethod
      this.InvoiceLineManager = InvoiceLineManager
      this.autoSaveDelay = (_.get(generalPrefs, 'settings.edition.automaticSaveDelay', 10) * 1000)
      this.autoSaveNgModelDebounce = this.autoSave ? 250 : false
      this.autoSave = _.get(generalPrefs, 'settings.edition.automaticSave', false)
      this.baseElement = null
      this.lines = []

      prefsPromise.then((prefs) => {
        if (!this.element._id && angular.equals({}, this.initParams)) {
          this.element.immediatePayment = (prefs.invoiceDelay === 0)
        }
        this.prefs = prefs
      })

      this.uploader = new FileUploader({
        url: urls.uploader + '/upload',
        autoUpload: true,
        alias: 'files',
        withCredentials: false,
        purpose: 'facturXFiles'
      })

      this.initParams = initParams
      this.warnings = initParams?.warnings || []
      this.element = (initParams && !angular.equals({}, initParams)) ? this.manager.create(initParams) : element
      if (initParams && initParams.adjustment !== undefined) {
        this.element.adjustment = initParams.adjustment
        ;(this.element.lines || []).forEach(function (line, i) {
          var srcLine = (initParams.lines || [])[i]
          if (srcLine && srcLine.adjustment !== undefined) {
            line.adjustment = srcLine.adjustment
          }
        })
      }
      if (model === 'creditNote' && this.element.adjustment) {
        var adj = this.element.adjustment
        ;(this.element.lines || []).forEach(function (line) {
          if (!line.adjustment) line.adjustment = !line.grant ? adj : 0
        })
      }
      this.fromQuote = fromQuote
      this.fromToDeposit = fromToDeposit
      this.customFields = _.sortBy(customFields, (c) => c.options.index)
      this.creditNotePagination = creditNotePagination
      this.vatList = angular.copy(vats)
      this.displayActivity = !!_.get(generalPrefs, 'settings.edition.displayActivity', false) // double inverse to debind from generalPrefs
      // Local vars
      this.isAdmin = SessionService.isAdmin()
      this.isValidator = SessionService.isValidator()
      this.allStocks = []
      this.bpuCount = 0
      this.bpus = []
      this.creditNotes = []
      this.directPaymentInfos = []
      this.entityInfos = []
      this.errors = []
      this.interventions = []
      this.loading = false
      this.pennylaneEmission = null
      this.pennylanePaStatus = null
      this.reverseVATSInfo = []
      this.subcontractInfos = []
      this.theForm = null
      this.vats = []
      this.facturXMimetypes = facturXMimetypes
      this.haveChorusAccess = false

      this.selectClientConfig = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual'],
        from: 'sufa'
      }
      this.selectDeliveryConfig = {
        title: 'Sélectionner une adresse de livraison',
        headerAction: 'Créer une nouvelle adresse de livraison',
        accessibleTypes: ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing'],
        from: 'sufa',
        parent: this.element.client,
        restrict: true
      }
    }

    /**
     * Check if element is editable
     * @return {boolean}
     */
    get editable () {
      return this.element.shouldRecompute()
    }

    /**
     * Check if element is editable or user is atleast validator
     * @return {boolean}
     */
    get allowValidatorEdit () {
      return this.isAdmin || this.isValidator || this.editable
    }

    /**
     * Check if element is editable or user is admin
     * @return {boolean}
     */
    get allowAdminEdit () {
      return this.isAdmin || this.editable
    }

    /**
     * Inverse allowAdminEdit
     * @return {boolean}
     */
    get disallowAdminEdit () {
      return !this.allowAdminEdit
    }

    /**
     * Return element generated number
     * @return {string}
     */
    get number () {
      if (!this.element?.date) {
        return ''
      }
      if (this.element.status !== 'draft') {
        return this.getNumberFor(this.element, this.model)
      }
    }

    get stampClasses () {
      switch (this.model) {
        case MODELS.INVOICE:
          if (this.element.status === 'paid') {
            return 'stamp paid'
          }
          break
        case MODELS.QUOTE:
          switch (this.element.status) {
            case 'refused':
              return 'stamp refused'
            case 'signed':
              return 'stamp signed'
            case 'invoiced':
              return 'stamp invoiced'
          }
          break
        case MODELS.CREDIT_NOTE:
          if (this.element.status === 'paid') {
            return 'stamp creditnote-paid'
          }
          break
      }
      return ''
    }

    // PUBLICS
    $onInit () {
      const disableAutoSaveFields = ['isModel', 'isArchived', 'isDeleted']
      disableAutoSaveFields.forEach((key) => {
        if (this.element[key]) this.autoSave = false
      })
      this._initWatchers()
      this._initElement()
      this._initDatePicker()
      this.availableStatus = this.getAvailableStatus()
      this._getBpuCount()
      this._initInterventions()
      if (this.$state.is('invoice.show')) {
        this._getCreditNotes()
      }
      this._initPennylaneEmission()
      this._initPennylanePaStatus()
      this._getVATs()
      this._setDates()
      this._change()

      this.uploader.filters.push({
        name: 'mimetypeCheck',
        fn: (file, filters, options) => {
          if (this.facturXMimetypes.find(mimetype => mimetype === file.type)) {
            if (file.name === 'factur-x.xml') {
              this.snackService.snack({
                text: `La pièce jointe ${file.name} possède un nom réservé, merci de changer le nom de votre pièce jointe`,
                delay: 10000
              })
              return false
            }
            return true
          } else {
            this.snackService.snack({
              text: "Ce format de pièce jointe n'est pas supporté",
              delay: 10000
            })
            return false
          }
        }
      })
    }

    /**
     * Save element, redirect if needed
     * @param element
     * @return {Promise}
     */
    save (element = this.element) {
      this.cancelAutoSaveTimeouts()
      this.$rootScope.loadingPage = true
      if (element.isModel && !element._id) {
        this.templateService.createPreFilledTemplate(element.type, element).then((e) => {
          this.templateService.checkTemplatesTitles(element.type, e).then((allowCreation) => {
            if (allowCreation) {
              element.modelTitle = e
              element.save().then(() => {
                this.snackService.snack({
                  text: this._getString('preFilledSaved'),
                  delay: 5000
                })
                this.$rootScope.loadingPage = false
                switch (element.type) {
                  case 'invoice':
                    return this.$state.go('invoice.show', { id: element._id })
                  default:
                    return this.$state.go('quote.show', { id: element._id })
                }
              })
            }
          })
        })
      } else {
        let promise
        switch (this.model) {
          case MODELS.INVOICE:
            promise = this._saveInvoice(element)
            break
          case MODELS.QUOTE:
            promise = this._saveQuote(element)
            break
          case MODELS.CREDIT_NOTE:
            promise = this._saveCreditNote(element)
            break
        }
        return promise.then((r) => {
          this.setDates()
          this.$rootScope.loadingPage = false
          if (this.autoSave) this.baseElement = JSON.parse(angular.toJson(this.element))
          return r
        })
      }
    }

    /**
     * Return available next status for element
     * @return {*}
     */
    getAvailableStatus () {
      return this.service.getAllowedStatus(this.element)
    }

    /**
     * Update element status
     * @param status
     * @return {Promise}
     */
    setStatus (status) {
      this.disableAutoUpdate = true
      this.loading = true
      return this.service.setStatus(this.element, status).then((element) => {
        this.$rootScope.loadingPage = true
        this._postValidate(element)
      })
    }

    /**
     * Validate element
     * @return {Promise<*>}
     */
    validate () {
      return this.service.setStatus(this.element, 'validated').then((element) => {
        this._postValidate(element)
      })
    }

    /**
     * Apply side effects to element
     * @param element
     * @return {Promise}
     */
    updateElement (element) {
      this.disableAutoUpdate = true
      this.element.payments = element.payments
      this.element.status = element.status
      this.element.history = element.history
      this.element.balanceDue = element.balanceDue
      this.element.balancePaid = element.balancePaid
      this.availableStatus = this.getAvailableStatus()
    }

    /**
     * Update delivery modal configuration
     */
    updateDelivery (next = {}, previous = '{}') {
      try {
        previous = JSON.parse(previous)
      } catch (e) {
        console.error('Failed to parse previous')
      }
      if (next._id !== previous._id) {
        this.element.delivery = null
      }
      if (this.model === 'invoice') {
        if (this.element.client) {
          this._getDueDate().then((date) => {
            this.element.dueDate = date
          })
        } else {
          this.element.dueDate = null
          this.element.date = null
        }
      }
      if (this.model === 'quote' && !this.element.client) {
        this.element.date = null
        this.element.dueDate = null
      }
      this.selectDeliveryConfig.parent = this.element.client
    }

    /**
     * Export element as pdf
     * @return {Promise}
     */
    asPdf () {
      return this.service.asPdf(this.element._id)
    }

    /**
     * Export element as pdf
     * @return {Promise}
     */
    asFacturX () {
      const invoiceNumber = this.utilService.getInvoiceNumber(this.element, 'facture', this.element.numberFormat) || ''
      if (
        invoiceNumber.length > 20
      ) {
        this.snackService.snack({
          text: 'Le numéro de facture est trop long, il ne doit pas dépasser 20 caractères.',
          delay: 10000
        })
      } else {
        return this.service.asFacturX(this.element._id)
      }
    }

    toChorus () {
      this.$rootScope.loading = true
      const isCreditNote = (this.element.getType() === 'creditNote')
      const invoiceNumber = this.utilService.getInvoiceNumber(this.element, 'facture', this.element.numberFormat) || ''
      if (
        invoiceNumber.length > 20
      ) {
        this.snackService.snack({
          text: 'Le numéro de facture est trop long, il ne doit pas dépasser 20 caractères.',
          delay: 10000
        })
        this.$rootScope.loading = false
      } else {
        this.displayService.displayConfirm(
          'Êtes vous sûr de vouloir exporter la facture sur Chorus ?',
          'Vous avez peut-être des modifications non sauvegardées'
        ).then(() => {
          return this.exportService.facturXValidation(this.element._id, true, isCreditNote).then((isValid) => {
            if (isValid) {
              this.$rootScope.loadingPage = true
              this.chorusService.deposerFlux(this.element._id, isCreditNote).then(() => {
                this.snackService.snack({
                  text: "Envoi sur Chorus en cours, suivi disponible sur l'onglet Chorus",
                  delay: 10000
                })
                this.$rootScope.loading = false
                return this.$state.reload()
              })
            }
          })
        })
      }
    }

    /**
     * Envoi de la facture sur Pennylane (facture électronique).
     * Calqué sur toChorus mais plus simple : pas de validation Factur-X côté
     * front (Pennylane rejette lui-même) ni de check de longueur du numéro.
     * Contrôle pré-émission des données client (checkInvoiceEmittable) :
     * bloquant sans client, avertissement + confirmation si champs incomplets.
     * Facture DÉJÀ envoyée (`sentToPennylane`) : le bouton reste disponible
     * (décision 2026-09-09) → confirmation dédiée (avertissement doublon) puis
     * renvoi FORCÉ via doForceReEmitToPennylane (au lieu de l'émission normale,
     * que le backend refuserait en 409). L'info « Facture envoyée sur
     * Pennylane » reste affichée : le flag n'est jamais remis à false ici.
     * Facture REJETÉE par la PA (`pennylanePaStatus.status === 'rejected'`) :
     * point d'entrée UNIQUE (plus de bouton dans le bandeau de rejet) →
     * délégation à reEmitToPennylane (renvoi « après rejet » classique, avec
     * sa question sur l'archivage ; le backend lève lui-même les marqueurs).
     */
    toPennylane () {
      if (this.pennylanePaStatus && this.pennylanePaStatus.status === 'rejected') {
        return this.reEmitToPennylane()
      }
      // `element.client` est peuplé sur la fiche (populates.show.invoice) →
      // contrôle complet possible, sans requête supplémentaire.
      const check = this.pennylaneService.checkInvoiceEmittable(this.element)
      if (check.blocking) {
        // Sans client, le backend rejettera systématiquement (422) : on bloque
        // avant le confirm plutôt que de laisser partir un envoi voué à l'échec.
        this.snackService.snack({
          text: 'Envoi impossible : ' + check.blocking,
          delay: 10000
        })
        return
      }
      const alreadySent = this.element.sentToPennylane === true
      let content = 'Vous avez peut-être des modifications non sauvegardées'
      if (alreadySent) {
        // Renvoi forcé : Pennylane NE déduplique PAS les imports → doublon si
        // l'ancienne facture n'a pas été archivée dans Pennylane. Libellé
        // statique (aucune donnée interpolée) → pas d'échappement nécessaire.
        content += '<br><br><strong class="text-danger">Cette facture a déjà été envoyée sur Pennylane.</strong> ' +
          'Un nouvel envoi créera un DOUBLON chez Pennylane si l\'ancienne facture n\'y a pas été archivée au préalable.'
      }
      if (check.warnings.length) {
        // Champs requis seulement si le customer n'existe pas encore chez
        // Pennylane (création) — la webapp ne peut pas le savoir →
        // avertissement, l'utilisateur tranche. Libellés 100 % statiques du
        // service (aucune donnée utilisateur/backend interpolée) → pas
        // d'échappement HTML nécessaire malgré le rendu ng-bind-html du dialog.
        content += '<br><br>Données client incomplètes :<ul>' +
          check.warnings.map((warning) => '<li>' + warning + '</li>').join('') +
          '</ul>L\'envoi peut échouer si ce client n\'existe pas encore chez Pennylane. Envoyer quand même ?'
      }
      this.displayService.displayConfirm(
        alreadySent
          ? 'Renvoyer la facture sur Pennylane malgré tout ?'
          : 'Êtes-vous sûr de vouloir envoyer la facture sur Pennylane ?',
        content
      ).then(() => {
        // Gating prod : bloque l'envoi si l'émission de factures n'est pas
        // autorisée côté Pennylane (inscription PA non activée). Vérification
        // au clic pour ne pas consommer le rate limit Pennylane (5 req/s) à
        // chaque affichage de page.
        return this.pennylaneService.getConnectedCompany().then((company) => {
          if (!company) {
            this.snackService.snack({
              text: 'Échec de l\'envoi sur Pennylane',
              delay: 10000
            })
            return
          }
          return this.pennylaneService.getPaRegistrations(company._id).then((res) => {
            if (!res.data.emissionAllowed) {
              this.snackService.snack({
                text: 'Émission de factures : Non autorisée',
                delay: 10000
              })
              return
            }
            return alreadySent ? this.doForceReEmitToPennylane() : this.doEmitToPennylane()
          })
        }).catch(() => {
          // getPaRegistrations a ignoreErrors [409,422,502,503] (pas de toast
          // global) : sans ce catch, un échec après confirmation serait
          // totalement silencieux. doEmitToPennylane catche déjà les siens.
          this.snackService.snack({
            text: 'Échec de l\'envoi sur Pennylane',
            delay: 10000
          })
        })
      })
    }

    /**
     * Appel réel d'émission : POST /invoices/emit côté backend-pennylane
     * (traitement asynchrone, réponse `{ accepted: N, items }`) puis reload de
     * la fiche. Le résultat réel (succès/échec par facture) est suivi par
     * PennylaneEmissionTrackerService (singleton : il survit au reload).
     * Hygiène loading : jamais laissé à true en cas d'erreur (pas de reload).
     * @return {Promise}
     */
    doEmitToPennylane () {
      this.$rootScope.loading = true
      return this.pennylaneService.emitInvoices([this.element._id]).then((res) => {
        this.snackService.snack({
          text: 'Envoi sur Pennylane en cours',
          delay: 10000
        })
        // Suivi du résultat par polling des Monitoring. Fallback silencieux si
        // `items` absent de la réponse (backend pas encore redéployé) =
        // comportement historique (pas de tracking, pas d'erreur console).
        // try/catch : le tracking est purement additif — un throw imprévu
        // (donnée dégénérée) ne doit jamais transformer un envoi accepté en
        // faux « Échec de l'envoi » ni empêcher le reload.
        try {
          const items = (res.data && res.data.items) || []
          if (items.length) {
            const label = this.number || this.element._id
            this.pennylaneEmissionTrackerService.track(items.map((item) => ({
              kiloInvoiceId: item.kiloInvoiceId,
              monitoringId: item.monitoringId,
              label: label
            })))
          }
        } catch (err) {
          console.warn('Suivi Pennylane non démarré', err)
        }
        this.$rootScope.loading = false
        return this.$state.reload()
      }).catch(() => {
        this.snackService.snack({
          text: 'Échec de l\'envoi sur Pennylane',
          delay: 10000
        })
        this.$rootScope.loading = false
      })
    }

    /**
     * Renvoi FORCÉ d'une facture DÉJÀ envoyée (depuis toPennylane, après la
     * confirmation « doublon » et le gating PA) : POST re-emit `{ force: true }`
     * → le backend lève ses gardes (statut PA, `sentToPennylane`), réinitialise
     * son Invoice locale et relance le pipeline (réponse `{ monitoringId }`).
     * Le flag `sentToPennylane` n'est PAS touché (ni ici ni côté Kilo) :
     * l'info « Facture envoyée sur Pennylane » reste affichée. Suivi du
     * résultat via le tracker (comme doEmitToPennylane) puis reload de la
     * fiche : le bandeau « Envoi en cours… » (_initPennylaneEmission) prend
     * le relais. Même hygiène `loading` que doEmitToPennylane.
     * Échecs attendus (ignoreErrors du service) → snack dédiée : 409 = verrou
     * « émission déjà en cours » (message FR backend si présent), 422 = sans
     * numéro, sinon générique.
     * @return {Promise}
     */
    doForceReEmitToPennylane () {
      this.$rootScope.loading = true
      return this.pennylaneService.reEmitInvoice(this.element._id, { force: true }).then((res) => {
        this.snackService.snack({
          text: 'Renvoi sur Pennylane en cours',
          delay: 10000
        })
        // try/catch : suivi purement additif, un throw imprévu ne doit jamais
        // transformer un renvoi accepté en faux échec ni empêcher le reload.
        try {
          const monitoringId = res && res.data && res.data.monitoringId
          if (monitoringId) {
            const label = this.number || this.element._id
            this.pennylaneEmissionTrackerService.track([{
              kiloInvoiceId: this.element._id,
              monitoringId: monitoringId,
              label: label
            }])
          }
        } catch (err) {
          console.warn('Suivi renvoi forcé Pennylane non démarré', err)
        }
        this.$rootScope.loading = false
        return this.$state.reload()
      }).catch((err) => {
        const status = err && err.status
        const backendMessage = err && err.data && typeof err.data.message === 'string' ? err.data.message : null
        let text = 'Échec du renvoi sur Pennylane'
        if (status === 409) {
          text = 'Renvoi impossible : ' + (backendMessage || 'une émission est déjà en cours pour cette facture')
        } else if (status === 422) {
          text = 'Renvoi impossible : ' + (backendMessage || 'facture non émissible')
        }
        this.snackService.snack({ text: text, delay: 10000 })
        this.$rootScope.loading = false
      })
    }

    /**
     * Renvoie une facture REJETÉE par la plateforme après correction (appelée par
     * toPennylane quand `pennylanePaStatus` est `rejected` — bouton unique). Confirmation
     * explicite (l'archivage de l'ancienne se fait manuellement dans Pennylane, le
     * renvoi crée une nouvelle facture). Puis POST re-emit + suivi via le tracker
     * (comme doEmitToPennylane). Échecs attendus (ignoreErrors service) → snack dédiée.
     */
    reEmitToPennylane () {
      this.displayService.displayConfirm(
        'Renvoyer la facture sur Pennylane ?',
        'Avez-vous archivé la facture rejetée dans Pennylane et corrigé les informations manquantes ?<br><br>' +
        'Le renvoi crée une NOUVELLE facture chez Pennylane.'
      ).then(() => {
        return this.pennylaneService.reEmitInvoice(this.element._id).then((res) => {
          this.snackService.snack({ text: 'Renvoi sur Pennylane en cours', delay: 5000 })
          // Le backend a remis sentToPennylane=false + effacé le statut PA : on aligne
          // l'état local (le bandeau PA disparaît, le bouton d'envoi se réactive) et on
          // suit le nouveau Monitoring (comme doEmitToPennylane, try/catch non fatal).
          this.pennylanePaStatus = null
          this.element.sentToPennylane = false
          const monitoringId = res && res.data && res.data.monitoringId
          if (monitoringId) {
            try {
              const label = this.number || this.element._id
              this.pennylaneEmissionTrackerService.track([{
                kiloInvoiceId: this.element._id,
                monitoringId: monitoringId,
                label: label
              }])
            } catch (err) {
              console.warn('Suivi renvoi Pennylane non démarré', err)
            }
          }
        }).catch((err) => {
          const status = err && err.status
          const text = status === 409
            ? 'Renvoi impossible : la facture n\'est pas en état rejeté par la plateforme.'
            : 'Échec du renvoi sur Pennylane'
          this.snackService.snack({ text: text, delay: 10000 })
        })
      })
    }

    /**
     * Export invoice as pdf with its interventions
     * @return {Promise}
     */
    asPdfWithInterventions () {
      return this.service.asPdfWithInterventions(this.element._id)
    }

    /**
     * Export element as pdf restricted to proforma templates
     * @return {Promise}
     */
    asProforma () {
      return this.service.asProforma(this.element._id)
    }

    /**
     * Export element as csv
     * @return {Promise}
     */
    asCsv () {
      return this.service.asCsv(this.element._id)
    }

    /**
     * Export element as spreadsheet
     * @return {Promise}
     */
    asSpreadsheet () {
      return this.service.asSpreadsheet(this.element._id)
    }

    /**
     * Duplicate element and redirect to new state
     * @return {Promise}
     */
    duplicate () {
      return this.service.duplicate(this.element)
    }

    /**
     * Send invoice quote or creditnote with send button
     * @return {Promise}
     */
    send () {
      switch (this.model) {
        case 'invoice':
          return this.service._sendInvoice(this.element)
        case 'quote':
          return this.service._sendQuote(this.element)
        case 'creditnote':
          return this.service._sendCreditNote(this.element)
        default:
          break
      }
    }

    /**
     * Cancel invoice paid by a creditnote
     * @return {Promise}
     */
    cancel () {
      return this.$uibModal.open({
        controllerAs: 'cancel',
        bindToController: true,
        resolve: {
          objType: function () { return 'invoice' }
        },
        templateUrl: '/app/modules/invoice/show/templates/cancel.template.html',
        controller: 'CancelInvoiceController'
      }).result.then((result) => {
        if (result) {
          this.cancelInvoice = true
          this.element.cancelByUser = true
          return this.element.save().then(() => {
            return this.createCreditNote().then((r) => {
              this.$state.reload()
              this.snackService.snack({
                text: this._getString('cancelled'),
                delay: 5000
              })
              this.cancelInvoice = false
            })
          })
        }
      })
    }

    /**
     * Create credit note base on current invoice
     * @return {Promise}
     */
    createCreditNote () {
      return this.creditNoteService.createCreditNoteFromPreferences().then((config) => {
        return this.creditNoteService.getDueDate(config).then((date) => {
          config.origin = 'invoice'
          config.client = this.element.client
          if (this.element.delivery) config.delivery = this.element.delivery
          config.invoiceRef = this.element._id
          config.title = `${STRINGS.invoice.createCreditNote} ${this.number}`
          config.rubrics = this.element.rubrics
          config.status = 'draft'
          config.dueDate = date
          config.adjustment = this.element.adjustment
          config.warnings = []

          /**
           * If we have a discount on either line or global, we need to apply those on lines to simplify edition afterward
           */
          if (this.element.globalDiscount || this.element.totalDiscount) {
            if (!this.element.globalDiscount) {
              // We can simply use computed value
              config.lines = this.element.lines.map((line) => {
                if (line.type !== 'simple_line') {
                  return line
                }
                line.price.amount = line.computed.discountedTotal
                line.quantity = 1
                line.discount = null
                return line
              })
              config.warnings.push(STRINGS.creditnote.warn_updated_prices)
            } else {
              // We need to check if we have computed this invoice with new mechanism,
              const hasComputedGlobalDiscount = this.element.lines.some((l) => l.computed.globalDiscounted)
              if (!hasComputedGlobalDiscount) {
                // we can't apply global discount and we need to fallback on old mechanism
                config.lines = this.element.lines
                config.globalDiscount = this.element.globalDiscount
              } else {
                config.lines = this.element.lines.map((line) => {
                  if (line.type !== 'simple_line') {
                    return line
                  }
                  line.price.amount = line.computed.globalDiscounted
                  line.quantity = 1
                  line.discount = null
                  return line
                })
                config.warnings.push(STRINGS.creditnote.warn_updated_prices)
              }
            }
          } else {
            // We don't have any discount, we can use existing lines
            config.lines = this.element.lines
          }

          if (this.cancelInvoice) {
            return this._saveCreditNote(config).then(r => {
              return this.service.makePayment(this.element, config)
            })
          } else {
            this.$state.go('creditnote.new', { initParams: config })
          }
        })
      })
    }

    controlCreditNote () {
      if (this.creditNotes.length > 0) {
        const msg = `Vous avez déja ${this.creditNotes.length} avoir${this.creditNotes.length > 1 ? 's' : ''} sur cette facture, veuillez confirmer`
        return this.displayService.displayConfirm('CREATION D\'AVOIR', msg).then(() => {
          this.createCreditNote()
        })
      } else {
        this.createCreditNote()
      }
    }

    /**
     * Update dates when toggling immediate payment input
     * @return {Promise}
     */
    checkImmediatePayment () {
      if (this.element.immediatePayment) {
        this.element.dueDate = null
      } else {
        if (this.element.date) {
          this._changeDueDate()
        }
      }
      return this._changePlaceHolder().finally(() => {
        this.$scope.$emit('formModified')
      })
    }

    /**
     * Open datepicker for start date
     * @return {Promise}
     */
    setStartDate () {
      if (this.disallowAdminEdit) return
      let opt
      if (this.element.dueDate) {
        opt = {
          maxDate: this.element.dueDate
        }
      }
      if (this.model === MODELS.INVOICE) {
        opt = {
          minDate: this.prefs?.emitPeriod?.start,
          maxDate: this.prefs?.emitPeriod?.end
        }
      } else if (this.model === MODELS.CREDIT_NOTE) {
        opt = {
          minDate: this.prefs?.emitPeriod?.start,
          maxDate: this.prefs?.emitPeriod?.end
        }
      }
      return this.datePickerService.getRange(this.element.date, opt).then((date) => {
        this.element.date = new Date(date.utcOffset(0, true))
        this.markDirty()
        return this._changeDueDate()
      })
    }

    /**
     * @return {void}
     */
    resetStartDate () {
      this.element.date = null
      this.markDirty()
    }

    setDelivery () {
      this.element.delivery = this.element.client
    }

    /**
     * Open datepicker for due date
     * @return {Promise}
     */
    setDueDate () {
      if (this.disallowAdminEdit) return this.$q.resolve()
      let opt
      if (this.element.date) {
        opt = {
          minDate: this.element.date
        }
      }
      return this.datePickerService.getRange(this.element.dueDate, opt).then((date) => {
        this.element.dueDate = new Date(date)
        this.markDirty()
      })
    }

    /**
     * @return {void}
     */
    resetDueDate () {
      this.element.dueDate = null
      this.markDirty()
    }

    /**
     * Parse date string as Date
     * @return {void}
     */
    setDates () {
      if (this.element.date) this.element.date = new Date(this.element.date)
      if (this.element.dueDate) this.element.dueDate = new Date(this.element.dueDate)
    }

    removeFile (key, item) {
      // self.model[key] = _.filter(self.model[key], function (f) {
      //   return f._id !== item._id
      // })
    }
    uploader (key, item) {
      // self.model[key] = _.filter(self.model[key], function (f) {
      //   return f._id !== item._id
      // })
    }

    /**
     * Remove prodived interventions from currrent element
     * @param interventions
     * @return {Promise}
     */
    removeInterventions (interventions = []) {
      if (!this.element.linkedData?.solica?.interventions) {
        return
      }
      const idList = interventions.map(({ _id }) => _id)
      this.element.linkedData.solica.interventions = this.element.linkedData.solica.interventions.filter((intervention) => {
        return !idList.includes(intervention?._id || intervention)
      })
      return this.save().then(() => {
        this.snackService.snack({
          text: 'Interventions déliées !',
          delay: 5000
        })
      })
    }

    /**
     * Add a new lines on current element
     * @return {void}
     * @param lines
     */
    accountItems (lines = []) {
      this.element.lines = [...this.element.lines, ...lines]
      this.element.save()
      // Switch to lines panel
      this.active = 0
    }

    /**
     * Return generated number
     * @param obj {Invoice | Quote | CreditNote}
     * @param type {'invoice'|'quote'|'creditnote'}
     * @return {string}
     */
    getNumberFor (obj, type) {
      if (!_.get(obj, 'date')) return
      if (obj.status === 'draft') return 'Brouillon'
      return this.utilService.getInvoiceNumber(obj, type, obj.numberFormat)
    }

    /**
     * Check if element has a global discount or at least one discount on lines
     * @return {boolean}
     */
    isDiscounted () {
      if (this.element.globalDiscount) return true
      return (this.element.lines || []).some(({ discount }) => !!discount)
    }

    /**
     * Mark form as dirty
     */
    markDirty () {
      this.theForm.$setDirty()
    }

    /**
     * Check if field is editable
     * @param field
     * @return {boolean}
     */
    isFieldEditable (field) {
      switch (field) {
        case 'reference':
        case 'legalFields':
        case 'description':
        case 'title':
        case 'marketNumber':
        case 'billingServiceCode':
        case 'facturXAttachments':
        case 'paymentMethod':
        case 'commitmentNumber':
          return (this.isAdmin && this.element.status !== 'paid') || (this.editable && this.element.status !== 'paid')
        case 'tags':
        case 'customFields':
          return true
        case 'referers':
        case 'linkInterventions':
        case 'payments':
          return (this.isValidator && this.element.status !== 'paid') || (this.editable && this.element.status !== 'paid')
        case 'compute':
          if (this.model === MODELS.CREDIT_NOTE) {
            return this.editable && !this.isDiscounted()
          }
          return (this.editable && this.element.status !== 'paid')
        default:
          return (this.editable && this.element.status !== 'paid')
      }
    }

    /**
     * Check if field is disabled
     * @param field
     * @return {boolean}
     */
    isFieldDisabled (field) {
      return !this.isFieldEditable(field)
    }

    createIntervention () {
      switch (this.model) {
        case MODELS.INVOICE:
          break
        case MODELS.QUOTE:
          return this.displayService.displayConfirm(
            'Êtes vous sûr de vouloir exporter le devis ?',
            'Vous avez peut-être des modifications non sauvegardées'
          ).then(() => {
            return this.$uibModal.open({
              controllerAs: 'select',
              bindToController: true,
              resolve: {
                type: function () { return 'quote' }
              },
              templateUrl: '/app/common/layouts/partials/modals/select-template.html',
              controller: 'SelectTemplateController'
            }).result.then((template) => {
              return this.service.createIntervention(this.element, template?._id || '')
            })
          })
        case MODELS.CREDIT_NOTE:
          break
      }
    }

    /**
     * Remove given warning
     * @param index
     */
    removeWarning (index) {
      this.warnings.splice(index, 1)
    }

    getInvoiceNumber (invoice) {
      if (invoice.status === 'draft') return 'Brouillon'
      return this.utilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat)
    }

    // PRIVATES

    /**
     * Init watchers on $scope
     * @private
     */
    _initWatchers () {
      this.$scope.$watch(() => this.crediNotes, () => {
        this._setCreditNotesDates()
      })
      this.$scope.$watch(() => this.theForm, () => {
        if (this.theForm && this.initParams && !angular.equals({}, this.initParams)) {
          this.markDirty()
          this.initParams = undefined
        }
      })

      this.$scope.$on('formModified', () => {
        this.markDirty()
      })

      if (this.autoSave) {
        this.$timeout(() => {
          this.baseElement = JSON.parse(angular.toJson(this.element))
          // manual debounce
          this.autoSaveTimeout = this.$timeout(function () { })
          this.$scope.$watch(() => this.element, (newValue, oldValue) => {
            this.$timeout.cancel(this.autoSaveTimeout)
            let newElement = JSON.parse(angular.toJson(newValue))
            let oldElement = JSON.parse(angular.toJson(oldValue))
            if (this.internalTimeout) this.$timeout.cancel(this.internalTimeout)
            this.autoSaveTimeout = this.$timeout(() => {
              this.autoUpdate(newElement, oldElement, newValue)
            }, 500)
          }, true)
          this.$scope.$on('$destroy', () => {
            this.cancelAutoSaveTimeouts()
            this.disableAutoUpdate = true
          })
        }, 250)
      }
    }

    autoUpdate (newElement, oldElement, saveObject) {
      if (!newElement._id) {
        const mandatoryFields = ['client', 'title']
        let mandatoryFieldsFilled = true
        mandatoryFields.forEach((elt) => {
          if (_.isEmpty(_.get(newElement, elt, null))) mandatoryFieldsFilled = false
        })
        if (mandatoryFieldsFilled) {
          this.autoSaveOngoing = _.uniqueId('autoSaveOngoing')
          this.internalTimeout = this.$timeout(() => {
            if (this.$state.is('invoice.new')) {
              return this._saveInvoice(saveObject)
            } else if (this.$state.is('quote.new')) {
              return this._saveQuote(saveObject)
            } else if (this.$state.is('creditnote.new')) {
              return this._saveCreditNote(saveObject)
            }
          }, this.autoSaveDelay)
        }
      } else {
        if (oldElement._id) {
          let sameValue = this.compareChanges(newElement, oldElement)
          // compare to baseElement to avoid useless requests
          sameValue = this.compareChanges(newElement, this.baseElement)

          if (sameValue) {
            this.cancelAutoSaveTimeouts()
          }

          if (this.disableAutoUpdate) {
            this.disableAutoUpdate = false
            return
          }

          if (_.isEmpty(newElement.title) || _.isEmpty(newElement.client)) return

          if (!sameValue) {
            this.autoSaveOngoing = _.uniqueId('autoSaveOngoing')
            this.internalTimeout = this.$timeout(() => {
              // return to scroll position
              const tempScrollY = window.scrollY
              return this.save(saveObject).then(() => {
                // wait for digest
                this.$timeout(() => {
                  window.scroll(0, tempScrollY)
                }, 1)
              })
            }, this.autoSaveDelay)
          }
        }
      }
    }

    compareChanges (newElement, oldElement) {
      const newObjKeys = Object.keys(newElement)
      let sameValue = true

      newObjKeys.forEach((key) => {
        switch (key) {
          case 'client':
            if (!_.isEqual(_.get(newElement, 'client._id', false), _.get(oldElement, 'client._id', false))) sameValue = false
            break
          case 'delivery':
            if (!_.isEqual(_.get(newElement, 'delivery._id', false), _.get(oldElement, 'delivery._id', false))) sameValue = false
            break
          case 'title':
          case 'lines':
          case 'description':
          case 'conditions':
          case 'legalNotices':
          case 'thanks':
            if (!_.isEqual(newElement[key], oldElement[key])) {
              sameValue = false
            }
            break
          case 'history':
          case '_balanceDue':
          case '_computed':
          case '_total':
          case '_totalVAT':
          case 'totalDiscount':
          case '_discountedTotal':
          case '_fullTotal':
          case 'invoiceDeposit':
          case 'bpu':
          case 'chorusFields':
            // dont'watch this
            return
          case 'customFields':
            let newElementCfields = JSON.stringify(_.get(newElement, key, {}))
            let oldElementCfields = JSON.stringify(_.get(oldElement, key, {}))
            if (!_.isEqual(newElementCfields, oldElementCfields)) sameValue = false
            break
          default:
            let newElementKey = _.isEmpty(_.get(newElement, key, '')) ? null : _.get(newElement, key, '')
            let oldElementKey = _.isEmpty(_.get(oldElement, key, '')) ? null : _.get(newElement, key, '')
            if (!_.isEqual(JSON.stringify(newElementKey), JSON.stringify(oldElementKey))) sameValue = false
            break
        }
      })
      return sameValue
    }

    cancelAutoSaveTimeouts () {
      if (this.autoSaveTimeout) this.$timeout.cancel(this.autoSaveTimeout)
      if (this.autoSaveOngoing) this.autoSaveOngoing = null
      if (this.internalTimeout) this.$timeout.cancel(this.internalTimeout)
    }

    /**
     *
     * @return {Promise<void>}
     * @private
     */
    _initDatePicker () {
      this.datePlaceHolder = moment(new Date()).toDate()
      return this._changePlaceHolder()
    }

    /**
     * Change date placeholder
     * @return {Promise<void>}
     * @private
     */
    _changePlaceHolder () {
      return this._getDueDate().then((date) => {
        this.dueDatePlaceHolder = date
      })
    }

    /**
     * Get dueDate based on element client or element prefs
     * @param date
     * @return {Promise<void>}
     * @private
     */
    _getDueDate (date = new Date()) {
      return this.service.getDueDate(this.element, date)
    }

    /**
     * Init element fields
     * @return {void}
     * @private
     */
    _initElement () {
      if (this.element.getType() === 'invoice' || (this.element.getType() === 'creditNote' && this.element.invoiceRef)) {
        this.appAccessService.getCompanyRights().then((rights) => {
          rights.forEach((right) => {
            if (right.appName === 'CHORUS' && right.hasAccess) this.haveChorusAccess = true
          })
        })
      }
      this.element.referers = this.element.referers || []
      this.element.status = this.element.status || 'draft'
      this.element.history = this.element.history || []
      this.element.tags = this.element.tags || []
      this.element.customFields = this.element.customFields || {}
      switch (this.model) {
        case MODELS.INVOICE:
          break
        case MODELS.QUOTE:
          this.lines = angular.copy(this.element.lines)
          this._initQuote()
          break
        case MODELS.CREDIT_NOTE:
          break
      }
    }

    /**
     * Get BPU count for display the input
     * @private
     * @return {Promise<number>}
     */
    _getBpuCount () {
      const query = this.bpuManager.query()
      query.opts.count = true
      return this.bpuManager.get(query)
        .then((data) => {
          this.bpuCount = data.data
          return data.data
        })
    }

    /**
     * Init intervention data
     * @return {Promise}
     * @private
     */
    _initInterventions () {
      if (this.$location.search().interventions) {
        const i = JSON.parse(this.$location.search().interventions)
        const query = this.interventionManager.query({
          populate: JSON.stringify([
            {
              path: 'linkedData.lifo.stockOut.stock',
              populate: [{ path: 'product' }]
            }
          ])
        }).select(i).fields('_id')
        return this.interventionManager.post(query).then((data) => {
          const existingInterventions = this.element.linkedData?.solica?.interventions || []
          const mapped = data.data.map(({ _id }) => _id)

          const result = [...new Set([...existingInterventions, ...mapped])]

          _.set(this.element, 'linkedData.solica.interventions', result)
          this.markDirty()
          return this.save()
        })
      }
      return this.$q.resolve()
    }

    /**
     * @return {void}
     * @private
     */
    _postValidate () {
      this.loading = false
      this.$rootScope.loadingPage = false
      this.$state.reload()
      this.theForm.$setPristine()
    }

    /**
     * Get credit notes linked to current element
     * @return {Promise<CreditNotes[]>}
     * @private
     */
    _getCreditNotes () {
      const creditNoteQuery = this.creditNoteManager
        .query()
        .select(this.element._id, 'invoiceRef')
        .paginate(this.creditNotePagination.toQueryOptions())

      this.loading = true
      return this.creditNoteManager.get(creditNoteQuery).then((data) => {
        this.creditNotes = data.data
        this.creditNotePagination.totalElements = data.meta.total
        this.loading = false
        return data.data
      })
    }

    /**
     * Consultation de l'état du dernier envoi Pennylane de la facture :
     * un GET au chargement de la fiche, puis POLLING (tick de 5 s, cap
     * 10 min) tant que le dernier Monitoring est « en cours »
     * (`pending`/`postponed`), pour que le bandeau évolue sans refresh
     * manuel. Couvre les échecs découverts après coup : navigateur fermé
     * pendant le suivi, dialog récapitulatif raté, envoi déclenché par un
     * autre utilisateur. Peut cohabiter avec le suivi post-clic de
     * PennylaneEmissionTrackerService (double polling toléré : lectures
     * idempotentes de GET /monitoring, aucune écriture).
     * Factures uniquement (pas avoir/devis), company connectée à Pennylane
     * requise. Une facture DÉJÀ envoyée (`sentToPennylane`) est suivie aussi
     * (décision 2026-09-09, renvoi forcé possible depuis la fiche) : un
     * renvoi forcé qui échoue ou est en cours doit se voir à côté du bandeau
     * « Facture envoyée sur Pennylane » — les deux informations sont alors
     * toutes deux vraies (envoyée une fois, dernier renvoi en échec/en cours).
     * Historique : l'ancienne exclusion évitait un « échec périmé » ; or le
     * dernier Monitoring d'une facture envoyée avec succès est `completed`
     * (rien à afficher), le cas ne se présente que si un renvoi a bien échoué.
     * Défensif de bout en bout : erreur réseau/réponse inattendue → aucun
     * affichage (`pennylaneEmission` reste null), aucune erreur console
     * (getConnectedCompany ne rejette jamais ; getLastEmissionMonitoring a
     * ses erreurs HTTP en ignoreErrors, le catch final absorbe le rejet).
     * Arrêts du polling : statut terminal (cf. _applyPennylaneMonitoring),
     * cap 10 min (bandeau « en cours » figé tel quel), départ de la fiche
     * (`$destroy`), ou re-init (jeton de génération : toute boucle
     * précédente devient inopérante, même avec une requête en vol).
     * @return {void}
     * @private
     */
    _initPennylaneEmission () {
      this.pennylaneEmission = null
      // Re-init : invalide une éventuelle boucle de polling précédente (le
      // jeton de génération rend inopérants ses ticks et réponses en vol) et
      // annule le tick programmé le cas échéant.
      this._pennylanePollGeneration = (this._pennylanePollGeneration || 0) + 1
      this._cancelPennylanePollTimeout()
      this._pennylanePollCount = 0
      if (this.model !== MODELS.INVOICE || !this.element._id) return
      // Listener enregistré UNE SEULE fois (même si la méthode est rappelée) :
      // plus aucun tick après avoir quitté la fiche.
      if (!this._pennylaneDestroyListenerRegistered) {
        this._pennylaneDestroyListenerRegistered = true
        this.$scope.$on('$destroy', () => {
          this._pennylanePollGeneration++
          this._cancelPennylanePollTimeout()
        })
      }
      const generation = this._pennylanePollGeneration
      this.pennylaneService.getConnectedCompany().then((company) => {
        if (!company) return
        return this.pennylaneService.getLastEmissionMonitoring(this.element._id).then((monitoring) => {
          if (generation !== this._pennylanePollGeneration) return
          // Au chargement initial (fromPolling=false), `completed` reste
          // « rien à afficher » comme historiquement : on ne pose PAS
          // `sentToPennylane` au load (risque de bandeau succès surgissant
          // sur de vieilles factures dont le write-back Kilo a échoué).
          if (this._applyPennylaneMonitoring(monitoring, false)) {
            this._schedulePennylanePollTick(generation)
          }
        })
      }).catch(angular.noop)
    }

    /**
     * Applique un Monitoring d'émission au bandeau `pennylaneEmission`.
     * Garde de compat (défense en profondeur) : un backend déployé SANS les
     * filtres de GET /monitoring ignorerait les query params et renverrait le
     * monitoring le plus récent du tenant quel qu'il soit (réception,
     * provisioning, émission d'une AUTRE facture) → bandeau mensonger. On
     * revalide donc type + facture côté client ; protège aussi de toute
     * réponse inattendue.
     * Mapping : `failed` → bandeau rouge ; `pending`/`postponed` (retry
     * planifié backend) → « en cours » ; `completed` → rien à afficher, et —
     * UNIQUEMENT pendant le polling (`fromPolling`) — hors skip
     * (`info.skipped`), `sentToPennylane` est posé localement : un Monitoring
     * `completed` signifie que la facture a été importée chez Pennylane
     * (`pennylaneInvoiceId` posé côté backend), c'est donc le vrai état
     * métier même si le write-back Kilo asynchrone a raté ; le bandeau succès
     * existant et la disparition du bouton « Envoyer sur Pennylane » suivent
     * tout seuls. Statut inconnu → aucun changement et arrêt du polling
     * (prudence).
     * @param monitoring Monitoring renvoyé par getLastEmissionMonitoring (ou null)
     * @param fromPolling true si appelé depuis la boucle de polling (vs chargement initial)
     * @return {boolean} true si l'état est « en cours » (poursuivre le polling)
     * @private
     */
    _applyPennylaneMonitoring (monitoring, fromPolling) {
      if (!monitoring || !monitoring.status) return false
      if (monitoring.type !== 'emission' || monitoring.kiloInvoiceRef !== this.element._id) return false
      if (monitoring.status === 'failed') {
        const info = monitoring.info || {}
        this.pennylaneEmission = {
          status: 'failed',
          // Mêmes formes de `Monitoring.info` que le tracker (failureReason).
          reason: info.upstreamMessage || info.message || info.reason || null,
          endedAt: monitoring.endedAt || null
        }
      } else if (monitoring.status === 'pending' || monitoring.status === 'postponed') {
        this.pennylaneEmission = { status: 'pending', reason: null, endedAt: null }
        return true
      } else if (monitoring.status === 'completed' && fromPolling) {
        // L'envoi suivi vient d'aboutir : on retire le bandeau « en cours ».
        this.pennylaneEmission = null
        if (!(monitoring.info && monitoring.info.skipped)) {
          // `completed` sans skip ⇒ facture importée chez Pennylane
          // (`pennylaneInvoiceId` posé côté backend) : vrai état métier même
          // si le write-back Kilo async a raté → le bandeau succès existant
          // (piloté par `sentToPennylane`) prend le relais.
          this.element.sentToPennylane = true
        }
      }
      return false
    }

    /**
     * Programme le prochain tick de polling du bandeau Pennylane (5 s), dans
     * la limite du cap de 10 minutes (120 ticks) : au-delà, le bandeau « en
     * cours » est figé tel quel et les requêtes s'arrêtent — cohérent avec
     * la limite assumée v1 côté backend, un Monitoring resté `pending` à
     * jamais (restart du pod en plein lot, caveat documenté) ne se terminera
     * jamais (cf. backlog « passer par une queue »).
     * Une erreur de l'appel (promesse rejetée : réseau/HTTP, tous en
     * ignoreErrors côté service) ne stoppe PAS le polling : le tick suivant
     * est reprogrammé, toujours dans la limite du cap.
     * @param generation jeton de génération capturé au démarrage de la boucle
     * @return {void}
     * @private
     */
    _schedulePennylanePollTick (generation) {
      if (generation !== this._pennylanePollGeneration) return // boucle périmée (re-init/$destroy)
      if (this._pennylanePollCount >= PENNYLANE_EMISSION_POLL_MAX_TICKS) return // cap atteint : bandeau figé
      this._pennylanePollTimeout = this.$timeout(() => {
        this._pennylanePollTimeout = null
        if (generation !== this._pennylanePollGeneration) return
        this._pennylanePollCount++
        return this.pennylaneService.getLastEmissionMonitoring(this.element._id).then((monitoring) => {
          if (generation !== this._pennylanePollGeneration) return
          if (this._applyPennylaneMonitoring(monitoring, true)) this._schedulePennylanePollTick(generation)
        }).catch(() => {
          // Erreur ponctuelle (réseau, 5xx…) : on continue le suivi.
          this._schedulePennylanePollTick(generation)
        })
      }, PENNYLANE_EMISSION_POLL_INTERVAL_MS)
    }

    /**
     * Annule le tick de polling Pennylane programmé, le cas échéant.
     * @return {void}
     * @private
     */
    _cancelPennylanePollTimeout () {
      if (this._pennylanePollTimeout) {
        this.$timeout.cancel(this._pennylanePollTimeout)
        this._pennylanePollTimeout = null
      }
    }

    /**
     * Statut e-invoicing de la facture chez la plateforme (PA), lu en LIVE via
     * getEInvoicingStatusByKilo (route backend dédiée). Complète le bandeau U5/U7
     * (basé sur notre Monitoring) : le REJET PA (« informations obligatoires
     * manquantes ») survient APRÈS un envoi réussi et n'est visible que par cette
     * route. Poll 5 s / cap 10 min tant que la PA valide (waiting_for_validation).
     * Défensif : company non connectée / synced:false / erreur → aucun bandeau.
     * @private
     */
    _initPennylanePaStatus () {
      this.pennylanePaStatus = null
      this._pennylanePaGeneration = (this._pennylanePaGeneration || 0) + 1
      this._cancelPennylanePaTimeout()
      this._pennylanePaPollCount = 0
      if (this.model !== MODELS.INVOICE || !this.element._id) return
      if (!this._pennylanePaDestroyListenerRegistered) {
        this._pennylanePaDestroyListenerRegistered = true
        this.$scope.$on('$destroy', () => { this._pennylanePaGeneration++; this._cancelPennylanePaTimeout() })
      }
      const generation = this._pennylanePaGeneration
      this.pennylaneService.getConnectedCompany().then((company) => {
        if (!company) return
        return this.pennylaneService.getEInvoicingStatusByKilo(this.element._id).then((status) => {
          if (generation !== this._pennylanePaGeneration) return
          if (this._applyPennylanePaStatus(status)) this._schedulePennylanePaTick(generation)
        })
      }).catch(angular.noop)
    }

    /**
     * Applique le statut e-invoicing PA au bandeau `pennylanePaStatus`.
     * rejected/refused → bandeau rouge + motif (renvoi proposé) ; waiting_for_validation
     * → « en cours » (poursuivre le polling) ; tout autre / synced:false → rien.
     * @return {boolean} true si « en cours » (poursuivre le polling)
     * @private
     */
    _applyPennylanePaStatus (status) {
      if (!status || !status.synced) { this.pennylanePaStatus = null; return false }
      const st = status.eInvoicingStatus
      if (st === 'rejected' || st === 'refused') {
        this.pennylanePaStatus = { status: 'rejected', reason: status.eInvoicingReason || null }
        return false
      }
      if (st === 'waiting_for_validation') { this.pennylanePaStatus = { status: 'pending' }; return true }
      this.pennylanePaStatus = null
      return false
    }

    /**
     * Programme le prochain tick de polling du statut PA (5 s), dans la limite
     * du cap de 10 minutes (120 ticks). Calqué sur _schedulePennylanePollTick :
     * jeton de génération (boucle périmée après re-init/$destroy), une erreur
     * ponctuelle de l'appel ne stoppe pas le polling (tick suivant reprogrammé
     * sous le cap).
     * @param generation jeton de génération capturé au démarrage de la boucle
     * @return {void}
     * @private
     */
    _schedulePennylanePaTick (generation) {
      if (generation !== this._pennylanePaGeneration) return // boucle périmée (re-init/$destroy)
      if (this._pennylanePaPollCount >= PENNYLANE_EMISSION_POLL_MAX_TICKS) return // cap atteint : bandeau figé
      this._pennylanePaTimeout = this.$timeout(() => {
        this._pennylanePaTimeout = null
        if (generation !== this._pennylanePaGeneration) return
        this._pennylanePaPollCount++
        return this.pennylaneService.getEInvoicingStatusByKilo(this.element._id).then((status) => {
          if (generation !== this._pennylanePaGeneration) return
          if (this._applyPennylanePaStatus(status)) this._schedulePennylanePaTick(generation)
        }).catch(() => {
          // Erreur ponctuelle (réseau, 5xx…) : on continue le suivi.
          this._schedulePennylanePaTick(generation)
        })
      }, PENNYLANE_EMISSION_POLL_INTERVAL_MS)
    }

    /**
     * Annule le tick de polling du statut PA programmé, le cas échéant.
     * @return {void}
     * @private
     */
    _cancelPennylanePaTimeout () {
      if (this._pennylanePaTimeout) {
        this.$timeout.cancel(this._pennylanePaTimeout)
        this._pennylanePaTimeout = null
      }
    }

    /**
     * @return {void}
     * @private
     */
    _getVATs () {
      this.vats = this.element.getVatInfos()
    }

    /**
     * Remove global discount on element if there's more than one VAT
     * @return {void}
     * @private
     */
    _removeGlobalDiscountIfNeeded () {
      if (_.get(this.element, 'globalDiscount') && !this.element.hasSingleVAT()) {
        this.element.globalDiscount = null
        if (this.notificationTimeout) {
          this.$timeout.cancel(this.notificationTimeout)
        }
        this.notificationTimeout = this.$timeout(() => {
          this.snackService.snack({
            text: `La remise globale a été supprimée car l'élément contient plusieurs TVA différentes`,
            delay: 5000
          })
          this.notificationTimeout = null
        })
      }
    }

    /**
     * Set dates on element as Date Object instead of string/moment
     * @private
     */
    _setDates () {
      if (this.element.date) this.element.date = new Date(this.element.date)
      if (this.element.dueDate) this.element.dueDate = new Date(this.element.dueDate)
    }

    /**
     * Store data from element on controller for easier access
     * @private
     */
    _change () {
      this.reverseVATSInfo = this._getReserveChargeVAT()
      this.subcontractInfos = this.element.subcontractorsInfos || []
      this.directPaymentInfos = this.element.directPaymentInfos
      this.entityInfos = this.subcontractInfos.reduce((acc, subcontractInfo) => {
        const directPayment = this.directPaymentInfos.find(({ entity }) => entity._id === subcontractInfo.entity._id)
        return [...acc, { entity: subcontractInfo.entity, subcontract: subcontractInfo, directPayment }]
      }, [])
    }

    /**
     *
     * @return {VATInfo[]}
     * @private
     */
    _getReserveChargeVAT () {
      const i = this._getKiloModel(this.element)
      return i.getReverseChargedVATInfos()
    }

    /**
     * @return {void}
     * @private
     */
    _setCreditNotesDates () {
      if (this.creditNotes.length) {
        this.creditNotes.forEach((creditNote) => {
          creditNote.date = new Date(creditNote.date)
          creditNote.dueDate = new Date(creditNote.dueDate)
        })
      }
    }

    /**
     *
     * @return {Promise<T>}
     * @private
     */
    _changeDueDate () {
      return this.service.changeDueDate(this.element).then((element) => {
        this.element = element
      })
    }

    /**
     * Get element parsed by KMC
     * @param elt
     * @return {Invoice | CreditNote | Quote }
     * @private
     */
    _getKiloModel (elt) {
      switch (this.model) {
        case MODELS.INVOICE:
          return new kiloMoneyCompute.Invoice(elt)
        case MODELS.QUOTE:
          return new kiloMoneyCompute.Quote(elt)
        case MODELS.CREDIT_NOTE:
          return new kiloMoneyCompute.CreditNote(elt)
      }
    }

    /**
     * Get string for givent action for current model
     * @param string {string}
     * @return {string}
     * @private
     */
    _getString (string) {
      const result = _.get(STRINGS, [this.model, string])
      if (!result) {
        console.error(`Unknown strings key ${string} for model ${this.model}`)
      }
      return result
    }

    /**
     *
     * @param element
     * @return {Promise}
     * @private
     */
    _saveInvoice (element) {
      if (!this.theForm.$dirty) {
        return this.$q.resolve(this.element)
      }
      this.loading = true
      this.$rootScope.loadingPage = true
      let populate
      if (this.element._id) {
        populate = JSON.stringify([
          { path: 'client' },
          { path: 'delivery' },
          { path: 'tags' },
          { path: 'referers' },
          { path: 'bpu', populate: [{ path: 'client' }] },
          { path: 'lines.subcontracts.entity' },
          { path: 'lines.product.productType' },
          { path: 'lines.productType' }
        ])
      }
      return element.saveWithQuery({ populate }).then((data) => {
        let snackString = element.isModel ? 'preFilledSaved' : 'saved'
        this.theForm.$setPristine()
        this.snackService.snack({
          text: this._getString(snackString),
          delay: 5000
        })
        if (this.$state.is('invoice.new') || this.$location.search().interventions) {
          this.$state.go('invoice.show', { id: element._id }, { reload: true })
        }
        if (this.autoSave) this.baseElement = JSON.parse(angular.toJson(this.element))
        this.loading = false
        this.$rootScope.loadingPage = false
      })
    }

    /**
     *
     * @param element
     * @return {Promise}
     * @private
     */
    _saveQuote (element) {
      if (!this.theForm.$dirty) {
        return this.$q.resolve(this.element)
      }
      this.loading = true
      this.$rootScope.loadingPage = true
      let populate
      if (this.element._id) {
        populate = JSON.stringify([
          { path: 'client' },
          { path: 'delivery' },
          { path: 'tags' },
          { path: 'referers' },
          { path: 'bpu', poulate: [{ path: 'client' }] },
          { path: 'lines.subcontracts.entity' },
          { path: 'lines.product.productType' },
          { path: 'lines.productType' },
          {
            path: 'linkedData.solica.interventions',
            populate: [
              {
                path: 'linkedData.lifo.stockOut.stock',
                // WE NEED TO GO DEEPER
                populate: [{ path: 'product' }]
              }
            ]
          }
        ])
      }
      return element.saveWithQuery({ populate }).then(() => {
        this.theForm.$setPristine()
        this.snackService.snack({
          text: this._getString('saved'),
          delay: 5000
        })
        if (this.$state.is('quote.new') || this.$location.search().interventions) {
          this.$state.go('quote.show', { id: element._id }, { reload: true })
        }
        if (this.autoSave) this.baseElement = JSON.parse(angular.toJson(this.element))
        this.loading = false
        this.$rootScope.loadingPage = false
      })
    }

    toPercent (quote) {
      return Number(((quote.depositPrice || 0) * 100) / quote.computed.fullTotal)
    }

    priceToPercent (quote) {
      if (!quote.depositPercent) {
        return this.toPercent(quote)
      } else {
        return quote.depositPrice
      }
    }
    /**
     *
     * @param element
     * @return {Promise}
     * @private
     */
    _saveCreditNote (element) {
      if (this.cancelInvoice) {
        return element.save().then(() => {
          return this.creditNoteService.setStatus(element, 'validated', this.cancelInvoice).then(() => {
            return this.creditNoteService.setStatus(element, 'sent', this.cancelInvoice).then(() => {
            })
          })
        })
      } else {
        if (!this.theForm.$dirty) {
          return this.$q.resolve(this.element)
        }
        this.loading = true
        this.$rootScope.loadingPage = true
        let populate
        if (this.element._id) {
          populate = JSON.stringify([
            { path: 'client' },
            { path: 'delivery' },
            { path: 'tags' },
            { path: 'referers' },
            { path: 'lines.subcontracts.entity' },
            { path: 'lines.product.productType' },
            { path: 'lines.productType' }
          ])
        }
        return element.saveWithQuery({ populate }).then(() => {
          if (element.adjustment) {
            var adj = element.adjustment
            ;(element.lines || []).forEach(function (line) {
              if (!line.adjustment) line.adjustment = !line.grant ? adj : 0
            })
          }
          this.theForm.$setPristine()
          this.snackService.snack({
            text: this._getString('saved'),
            delay: 5000
          })
          if (this.$state.is('creditnote.new') || this.$location.search().interventions) {
            this.$state.go('creditnote.show', { id: element._id }, { reload: true })
          }
          if (this.autoSave) this.baseElement = JSON.parse(angular.toJson(this.element))
          this.loading = false
          this.$rootScope.loadingPage = false
        })
      }
    }

    /**
     * Check if quote should be duplicated
     * @return {Promise}
     * @private
     */
    _initQuote () {
      const restrictedStatus = ['invoiced', 'draft', 'refused', 'signed']
      const isAfter = moment().isAfter(this.element.dueDate)
      const isInStatus = restrictedStatus.includes(this.element.status)
      if (!isInStatus && isAfter) {
        return this._askQuoteDuplicate()
      }
    }

    /**
     * @return {Promise}
     * @private
     */
    _askQuoteDuplicate () {
      return this.$uibModal.open({
        bindToController: true,
        controllerAs: 'clone',
        templateUrl: '/app/modules/quote/show/templates/quote-clone.template.html',
        controller: 'QuoteCloneController'
      }).result.then((res) => {
        if (res) {
          return this.duplicate()
        }
      })
    }
  }

  ElementShowController.$inject = [
    // Urls
    'urls',
    // Angular
    '$http', '$location', '$q', '$scope', '$rootScope', '$state', '$timeout', '$uibModal',
    // Managers
    'BpuManager', 'CreditNoteManager', 'InterventionManager',
    // Services
    'CreditNoteService', 'DatePickerService', 'DisplayService', 'ExportService', 'InvoiceService', 'PaymentService', 'PreferencesService',
    'QuoteService', 'ReferersService', 'SessionService', 'SnackService', 'StatusService', 'TokenSwitcherService', 'UtilService', 'TemplateService', 'AppAccessService', 'ChorusService', 'PennylaneService', 'PennylaneEmissionTrackerService',
    // Resolve
    'creditNotePagination', 'customFields', 'fromQuote', 'fromToDeposit', 'generalPrefs', 'initParams', 'element', 'vats', 'model', 'FileUploader', 'facturXMimetypes', 'facturXPaymentsMethod', 'InvoiceLineManager'
  ]

  angular
    .module('kilo.common.controllers')
    .controller('ElementShowController', ElementShowController)
})(window.angular, window._, window.moment, window.kiloMoneyCompute)
